// PizzaToons Mock Data

export const heroContent = {
  headline: "India's Growing Pizza Franchise – Built on Quality, Not Hype",
  subline: "100% hygiene • 100% support • 100% transparency",
  ctaPrimary: "Explore Our Story",
  ctaSecondary: "Start Your Franchise Journey",
  videoUrl: "https://images.unsplash.com/photo-1558138838-76294be30005?auto=format&fit=crop&w=1920&q=80"
};

export const storyContent = {
  sections: [
    {
      id: 1,
      title: "The Beginning",
      text: "We didn't start with marketing, we started with quality.",
      year: "2019"
    },
    {
      id: 2,
      title: "First Smiles",
      text: "Customers became our promoters.",
      year: "2019"
    },
    {
      id: 3,
      title: "Growing Family",
      text: "Franchisees became our family.",
      year: "2021"
    },
    {
      id: 4,
      title: "Pune & Beyond",
      text: "Strategic expansion across Pune & PCMC.",
      year: "2024"
    }
  ]
};

export const founderContent = {
  name: "Mr. Akshay Bankar",
  title: "Founder & Director\n( Pizzatoons Foods & Beverages Private Limited )",
  image: "/akshay.webp",
  message: `Pizzatoons was never about opening outlets fast, it was about doing things right. Every pizza we make carries our promise of quality. Every franchise we open is a partnership built on trust. We believe in growing together – one slice at a time.`,
  quote: "Quality is not an act, it's a habit."
};

export const growthStats = {
  outlets: 48,
  customersServed: 200000,
  franchiseRetention: 100,
  yearsInBusiness: 7,
  highlight: "🚫 No Paid Marketing – ✅ Only Word of Mouth & Repeat Customers"
};

import outletsRaw from './outlets.json';
export const outlets = outletsRaw;


export const supplyChainItems = [
  {
    id: 1,
    title: "Central Kitchen",
    description: "State-of-the-art facility ensuring consistent quality",
    icon: "ChefHat"
  },
  {
    id: 2,
    title: "Warehouse",
    description: "Strategic storage with optimal conditions",
    icon: "Warehouse"
  },
  {
    id: 3,
    title: "Cold Chain Logistics",
    description: "Temperature-controlled delivery network",
    icon: "Snowflake"
  },
  {
    id: 4,
    title: "Daily Dispatch",
    description: "Fresh ingredients delivered every day",
    icon: "Truck"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Amit Patil",
    location: "Kothrud Outlet",
    text: "Why I chose Pizzatoons? The transparency. From day one, everything was crystal clear.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&w=150&q=80",
    rating: 5
  },
  {
    id: 2,
    name: "Priya Deshmukh",
    location: "Pimpri Outlet",
    text: "The support I received was incredible. They treat franchisees like family.",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=150&q=80",
    rating: 5
  },
  {
    id: 3,
    name: "Suresh Kumar",
    location: "Hinjewadi Outlet",
    text: "My business growth journey has been amazing. ROI in just 14 months!",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=150&q=80",
    rating: 5
  },
  {
    id: 4,
    name: "Neha Sharma",
    location: "Baner Outlet",
    text: "The training and continuous support made me confident from the very first day.",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=150&q=80",
    rating: 5
  }
];

export const videoTestimonials = [
  {
    id: 1,
    videoId: "Wei6dduiHLE",
    title: "How Friends Opened 5 PizzaToons Outlet In Just 1 Year | Success Story | Pizzatoons"
  },
  {
    id: 2,
    videoId: "Js8VIhW4iBg",
    title: "Don't Underestimate Women Entrepreneurs | How She Earns In Lakhs | Pizzatoons"
  },
  {
    id: 3,
    videoId: "c10UL5Cpw5I",
    title: "From Customer to Franchise Owner | Employee to Boss Story | Pizzatoons"
  },
  {
    id: 4,
    videoId: "tRTK7ZSjnAc",
    title: "I Quit My IT Job for This! 😳🍕 | Pizzatoons Success Story"
  }
];



export const kioskVsStoreComparison = {
  kiosk: {
    title: "Kiosk Model",
    issues: [
      "Hygiene concerns",
      "Rain & weather problems",
      "Corporation compliance issues",
      "No seating arrangement",
      "Limited menu options"
    ]
  },
  store: {
    title: "Store Model",
    benefits: [
      "Premium look & feel",
      "FSSAI compliant",
      "Better sales potential",
      "Brand trust & recognition",
      "Comfortable dining experience"
    ]
  }
};

export const franchiseModel = {
  investment: "₹12–15 Lakhs",
  distanceRule: "3 KM",
  model: "FOFO (Franchise Owned, Franchise Operated)",
  steps: [
    { id: 1, title: "Enquiry", description: "Fill out the franchise enquiry form" },
    { id: 2, title: "Discussion", description: "Have a detailed discussion with our team" },
    { id: 3, title: "Location", description: "Select and finalize your store location" },
    { id: 4, title: "Agreement", description: "Sign the franchise agreement" },
    { id: 5, title: "Setup", description: "Store setup with our guidance" },
    { id: 6, title: "Training", description: "Complete training program" },
    { id: 7, title: "Launch", description: "Grand opening of your outlet" },
    { id: 8, title: "Support", description: "Ongoing support & assistance" }
  ]
};

export const missionVisionValues = {
  mission: "Serve quality food with dignity and create memorable dining experiences for every customer.",
  vision: "Build India's most trusted pizza franchise network, one happy customer at a time.",
  values: [
    { title: "Hygiene", description: "Uncompromising cleanliness standards" },
    { title: "Transparency", description: "Clear and honest business practices" },
    { title: "Support", description: "Complete franchisee handholding" },
    { title: "Growth", description: "Mutual success for all partners" }
  ]
};

export const contactInfo = {
  address: "4th floor, Amanora Crest Building, Amanora Town Centre, Amanora Park Town, Hadapsar, Pune, Maharashtra 411028",
  phone: "07875550787",
  email: "info@pizzatoons.in",
  workingHours: "Mon - Sat: 10:00 AM - 6:00 PM",
  mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3782.9427046447457!2d73.8397!3d18.5265!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTjCsDMxJzM1LjQiTiA3M8KwNTAnMjMuMCJF!5e0!3m2!1sen!2sin!4v1234567890"
};

export const socialLinks = {
  instagram: "https://www.instagram.com/pizzatoons.in",
  facebook: "https://www.facebook.com/PizzaBytes.in/",
  youtube: "https://www.youtube.com/@pizzatoonss"
};
